/**
 * Where patrol-web keeps its last good feature-flag read (UAT-BLOCKERS D1 item 11, owner ruling "Remember the last
 * good read"): the app's ONE `StorageService`. A LEAF — it imports nothing from the app — because both the flags reader
 * (`flagsApi.js`) and the auth storage (which clears it on sign-out) read it.
 *
 * @module core/featureFlags/flagLastReadStore
 */

import { createFlagLastReadStore } from '@puffin-core/feature-flags/react-http';
import { StorageService } from '@puffin-core/storage';

export const flagLastReadStore = createFlagLastReadStore({ storage: StorageService.getInstance() });
